import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as ArrowIcon } from "../../../assets/icons/arrow-down-dropdown.svg";
import { LESSON_TABLE_ALL_ACTIONS_TYPE } from "../../../redux/actions-type";

export const LessonTypesDropdown = ({ statusType, deviceType = "" }) => {
  const dispatch = useDispatch();
  const { type: selectedType } = useSelector(
    (state) => state.lessonTablePagination
  );

  const lessonTypes = [
    { key: "all", name: "Bütün dərslər" },
    { key: "main", name: "Əsas dərslər" },
    { key: "lab", name: "Lab dərslər" },
  ];

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleClick = (item) => {
    dispatch({
      type: LESSON_TABLE_ALL_ACTIONS_TYPE.GET_LESSON_TYPE,
      payload: item.key,
    });
    setDropdownOpen(false);
  };

  return (
    <div
      className={`global-category-dropdown dropdown-name data-status ${deviceType} ${
        dropdownOpen ? "active" : ""
      }`}
    >
      <div
        className="dropdown-head"
        onClick={() => setDropdownOpen(!dropdownOpen)}
      >
        <h2>{lessonTypes.find((item) => item.key === selectedType).name}</h2>
        <div className="arrow-icon">
          <ArrowIcon />
        </div>
      </div>

      <div className="dropdown-body">
        <ul>
          {lessonTypes.map((item) => (
            <li key={item.key} onClick={() => handleClick(item)}>
              {item.name}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
